import { useEffect, useState } from "react";
import { Layout } from "../components/Layout";
import { Card } from "../components/Card";
import "./HomePage.css";

interface MeResponse {
  client: { client_id: string } | null;
  meta?: { connected: boolean; status: string | null };
}

export function HomePage() {
  const [me, setMe] = useState<MeResponse | null>(null);

  useEffect(() => {
    fetch("/api/me", { credentials: "include" })
      .then((r) => r.json())
      .then(setMe)
      .catch(() => setMe({ client: null }));
  }, []);

  if (me === null) {
    return (
      <Layout>
        <div className="home-hero">
          <span className="label">Retrofit AI Monitor</span>
          <h1>Loading…</h1>
        </div>
      </Layout>
    );
  }

  const signedIn = !!me.client;
  const connected = !!me.meta?.connected;

  return (
    <Layout clientId={me.client?.client_id}>
      <div className="home-hero">
        <span className="label">Retrofit AI Monitor</span>
        <h1>
          Know the second a campaign starts
          <br />
          <span className="home-hero__accent">losing money.</span>
        </h1>
        <p className="home-hero__sub">
          Your agency runs more ad accounts than anyone can keep eyes on. We watch all of
          them — and tell you the moment one needs your attention.
        </p>
        <div className="home-hero__cta">
          {!signedIn && (
            <a className="home-hero__btn-primary" href="/login">
              Sign in
            </a>
          )}
          {signedIn && !connected && (
            <a className="home-hero__btn-primary" href="/meta/start">
              Connect Meta
            </a>
          )}
          {signedIn && connected && (
            <>
              <a className="home-hero__btn-primary" href="/dashboard">
                Open dashboard
              </a>
              <a className="home-hero__btn-secondary" href="/settings">
                Notifications
              </a>
            </>
          )}
        </div>
      </div>

      <div className="home-features">
        <Card>
          <h3>Nothing slips through</h3>
          <p style={{ color: "var(--color-bone-dim)", margin: "8px 0 0" }}>
            Every account in your book is covered — even the ones you haven't looked at
            this week.
          </p>
        </Card>
        <Card>
          <h3>You hear it first</h3>
          <p style={{ color: "var(--color-bone-dim)", margin: "8px 0 0" }}>
            You catch it before your client does. A problem in the numbers reaches you,
            not their inbox.
          </p>
        </Card>
        <Card>
          <h3>Quiet until it counts</h3>
          <p style={{ color: "var(--color-bone-dim)", margin: "8px 0 0" }}>
            No dashboard to babysit. It stays out of your way until something genuinely
            needs you.
          </p>
        </Card>
      </div>
    </Layout>
  );
}
